import React from 'react';
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Card, CardBody, Col, Collapse, Row} from "reactstrap";
import {Button as SementicBtn, Button, Icon, Label, Radio} from "semantic-ui-react";
import * as tbl_headers from "../user_group_table_headers_util";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_tag";
import apiConfig from "../../../axios/axios_api_services";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import * as common from "../../../const/Common/CommonFunc";
import {withRouter} from "react-router-dom";
import * as innerRoutes from "../user_group_route_util";
import './add_user_content_style.scss';

class AddUsersContent extends React.Component {

  state = {
    corporateId: null,
    userGroupId: null,
    users: [],
    selected: []
  };

  componentDidMount() {
    let userGroupDetails = this.props.userGroupDetails;
    if(userGroupDetails !== null && userGroupDetails !== undefined) {
      let userGroupId = userGroupDetails.userGroupId;
      let corporateId = userGroupDetails.corporateId;
      this.setState({
        corporateId: corporateId,
        userGroupId: userGroupId
      });
      this.callData(corporateId);
    } else {
      this.props.history.push(innerRoutes.inner_route_tags_user_groups);
    }
  }

  callData = (corporateId) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axios.get(apiConfig.CORPORATE_USER_GROUP_USER_NOT_IN_GROUP(corporateId),{headers:headers}).then(r =>{
      if(r.status === 200) {
        if(r.data.success) {
           if(r.data.users) {
             if(r.data.users.length!==0) {
               let user_list = [];
               r.data.users.map((d, i)=>{
                 let obj = {
                   active: true,
                   data: d
                 };
                 user_list.push(obj);
               });
               this.setState({
                 users: user_list
               });
             }
           }
        }
      }
    }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.callData(corporateId);
      }
    }).finally(fin => {
      this.props.spinnerHandler(false);
    });
  };

  addUserToQu = (r, i) => {

    let selected = this.state.selected;
    let users = this.state.users;
    let cd_obj = {
      u_index: i,
      data: r
    };
    selected.push(cd_obj);

    let user = users[i];
    user.active = false;

    this.setState({
      selected: selected
    })

  };

  removeUserFromQu = (r, i) => {

    let selected = [...this.state.selected];
    let users = this.state.users;

    let selectedElement = selected[i];
    let index = selectedElement.u_index;

    let user = users[index];
    user.active = true;

    selected.splice(i, 1);
    this.setState({
      selected: selected
    })

  };

  sendToBackend = () => {
    let user_id_list = [];
    if(this.state.selected) {
      if(this.state.selected.length!==0) {
        this.state.selected.map((r, i)=>{
          user_id_list.push( r.data.userId );
        });
      }
    }
    let obj = {
      users : user_id_list
    };
    this.sendToBackend_(obj);
  };

  sendToBackend_ = (obj) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    this.props.spinnerHandler(true);
    axios.post(apiConfig.CORPORATE_ADD_USERS_TO_USER_GROUP( this.state.userGroupId ), obj, {headers:headers}).then(r =>{
      if(r.status === 200) {
        if(r.data.success) {
          common.warningAlert(r.data.message, 0);
          this.props.closeModal();
        }}
    }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.sendToBackend_(obj);
      }
    }).finally(fin => {
      this.props.spinnerHandler(false);
    });
  };

  render() {

    let {users, selected} = this.state;

    let row = [];

    if(users) {
      if(users.length!==0) {
        users.map((o, i)=>{
          let active = o.active;
          let r = o.data;
          let obj = {
            user_id: r.userId,
            employee_id: r.empId,
            first_name: r.firstName,
            last_name: r.lastName,
            nic: r.identificationValue,
            mobile: r.mobile,
            email: r.email,
            active: r.status,
            add: <div>
              {
                !active?<p>Added</p>:
                  <SementicBtn
                    circular
                    icon='add'
                    disabled={ !active }
                    onClick={() => this.addUserToQu(r, i)}
                  />
              }
            </div>,
          };
          row.push(obj);
        });
      }
    }

    let draftData = {columns: tbl_headers.ADD_USERS_TBL_HEADERS, rows: row};

    let candidate_lbls = [];

    if(selected) {
      if(selected.length!==0) {
        selected.map((r, i)=>{
          let cd_obj =  <Label as='a'>
                          { r.data.firstName }
                          {/*<Icon name='delete' onClick={ ()=>this.removeUserFromQu(r, i) }/>*/}
                          <button
                            className="ui icon button cd_lbl_btn"
                            onClick={ ()=>this.removeUserFromQu(r, i) }
                          >
                            <i className="close icon cd_lbl_icon"></i>
                          </button>
                        </Label>;
          candidate_lbls.push(cd_obj);
        })
      }
    }

    return(
            <div>

              <Row>
                <Col lg={"12"} style={{marginBottom: '5px', marginTop: '10px', textAlign: "end"}}>
                  <Button
                    className="px-5"
                    disabled={ selected === null?true:selected.length === 0?true:false }
                    onClick={this.sendToBackend}
                  ><i aria-hidden="true" className="plus icon"></i>
                    Submit
                  </Button>
                </Col>
              </Row>

              <Card>
                <Collapse isOpen={true} id="collapseExample">
                  <CardBody>

                    { candidate_lbls }

                  </CardBody>
                </Collapse>
              </Card>

              <Card>
                <Collapse isOpen={true} id="collapseExample">
                  <CardBody>
                    <MDBDataTable
                      searching={true}
                      displayEntries={true}
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      bordered
                      hover
                      data={draftData}
                    />
                    {/*:*/}
                    {/*<div className={"align-center fully-width"}>*/}
                    {/*  <Empty description={"Records not found"} className={"empty-icon"}/>*/}
                    {/*</div>*/}
                  </CardBody>
                </Collapse>
              </Card>

            </div>
    )
  }

}

const mapStateToProps = (state) => ({
  user_group: state.userGroupReducer.userGroupDetails,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setUserGroupHandler: (data) => dispatch(actionCreator.saveUserGroupDetails(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddUsersContent));
